import React from "react";
import { useI18n } from "../i18n/I18nContext";

export default function StatusBar() {
  const { t, locale, setLocale } = useI18n();
  return (
    <div className="statusbar" data-testid="statusbar">
      <div className="container-edge w-full flex items-center justify-between gap-4">
        <a href="#top" className="mono" style={{ color: "var(--ink)" }} data-testid="brand-mark">
          {t.status.mark}
        </a>
        <div className="flex items-center gap-3" data-testid="lang-switcher">
          {["en", "es", "ja"].map((l, i) => (
            <React.Fragment key={l}>
              {i > 0 && <span className="mono" style={{ color: "rgba(26,24,22,0.2)" }}>·</span>}
              <button
                type="button"
                onClick={() => setLocale(l)}
                className="lang-btn"
                aria-pressed={locale === l}
                data-testid={`lang-switcher-${l}`}
              >
                {l}
              </button>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
